<template>
  <!-- 
    Used to draw areas on a map that will be used by the eventMovies
   -->
  <Portlet
    :title="$t('eventMovie')"
    icon="video"
    class="eventMovie"
  >
    <template slot="buttons">
      <router-link
        v-if="!authenticationHasRole('zerolevel')"
        :to="`/installation/${ installationId }/eventmovie/configure`"
        class="btn btn-secondary btn-sm"
      >
        <font-awesome-icon
          class="mr-2"
          icon="edit"
        />
        <span>{{ $t('configure') }}</span>
      </router-link>
      <toggle-button
        v-model="baseLayerBool"
        :labels="{ checked: $t('map'), unchecked: $t('satellite') }"
        :color="{ checked: 'gray', unchecked: 'green' }"
        :width="80"
        :height="30"
        :font-size="10"
        class="m-0 ml-4"
        @change="changeBaseLayer()"
      />
    </template>
    <div>
      <div id="eventMovieWrapper" />
    </div>
  </Portlet>
</template>

<script>
import { authenticationMixin } from '@/mixins/authenticationMixin';
import { errorMixin } from '@/mixins/errorMixin.js';
import L from 'leaflet';
import 'leaflet-draw';

(function () {
  var originalOnTouch = L.Draw.Polyline.prototype._onTouch;
  L.Draw.Polyline.prototype._onTouch = function ( e ) {
    if ( e.originalEvent.pointerType != 'mouse' ) {
      return originalOnTouch.call(this, e);
    }
  }
})();


export default {
  name: 'EventMovie',
  mixins: [
    authenticationMixin,
    errorMixin
  ],
  props: {
    installationId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      redMarkerSource: 'data:image/png;base64,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',
      blueMarkerSource:'data:image/png;base64,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',
      locationMarker: null,
      baseLayers: null,
      trainIntervalVar: null,
      cancelSource: null,
      baseLayerBool: true,
      currentId: null,
      colors: [
        'red',
        'blue',
        'green',
        'firebrick',
        'black',
        'aqua',
        'cadetblue',
        'chartreuse',
        'coral',
        'cornflowerblue',
        'crimson',
        'darkorange',
        'deeppink',
        'brown',
        'pink',
        'darkblue',
        'darkgreen',
        'lightblue'
      ],
      layerLength: 0,
      searchText: '',
      mapAttrib: '&copy; <a href="http://www.esri.com/">Esri</a>',
      mapUrl: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      wikiAttrib: '&copy; <a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
      wikiUrl: 'https://a.tile.openstreetmap.org/${z}/${x}/${y}.png',
      contributionUrl: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      mapIndex: 0,
      initialised: false,
      editableLayers: null,
      map: null,
      attribution: this.wikiAttrib,
      zoom: 6,
      maxZoom: 18,
      url: this.wikiUrl,
      polygonData: null,
      trains: null,
      mappedTrains: []
    }
  },
  computed: {
    redIcon () {
        return new L.Icon({
            iconUrl: this.redMarkerSource,
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
          });
    },
    blueIcon () {
      return new L.Icon({
            iconUrl: this.blueMarkerSource,
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
          });
    },
    currentLayer () {
      let temporaryLayers = this.editableLayers.getLayers();
      let temporaryLayer = temporaryLayers.find(layer => {
        return Number(layer.id) === Number(this.currentId);
      });
      return temporaryLayer;
    },
    bounds () {
      let corner1 = null;
      let corner2 = null;
      if (this.polygonData != null) {
        corner1 = {latitude: 0, longitude: 0};
        corner2 = {latitude: 0, longitude: 0};
        this.polygonData.forEach((area, areaIndex) => {
          area.positions.forEach((position, positionIndex) => {
            if (position.latitude == null) {
              return;
            }
            if (areaIndex == 0 && positionIndex == 0) {
              corner1.latitude = position.latitude;
              corner1.longitude = position.longitude;
              corner2.latitude = position.latitude;
              corner2.longitude = position.longitude;
            } else {
              if (position.latitude < corner1.latitude) {
                corner1.latitude = position.latitude;
              }
              if (position.longitude < corner1.longitude) {
                corner1.longitude = position.longitude;
              }
              if (position.latitude > corner2.latitude) {
                corner2.latitude = position.latitude;
              }
              if (position.longitude > corner2.longitude) {
                corner2.longitude = position.longitude;
              }
            }
          });
        });
        corner1 = L.latLng(corner1.latitude, corner1.longitude);
        corner2 = L.latLng(corner2.latitude, corner2.longitude);
      } else {
        corner1 = L.latLng(48.980216985374994, 17.314453125000004);
        corner2 = L.latLng(46.55886030311719, 9.931640625000002);
      }
      let bounds = L.latLngBounds(corner1, corner2);
      return bounds;
    }
  },
  async mounted () {
    this.wikiUrl = `https://a.tile.openstreetmap.org/{z}/{x}/{y}.png`; 
    await this.getEventMovieArea();
    await this.getTrainPositions();
    this.initMap();
    this.createInterval();
  },
  beforeDestroy () {
    if (this.map != null) {
      this.map.remove();
      this.cancelInterval(); //not working
      this.cancelRequest();
    }
  },
  methods: {
    createInterval () {
      this.trainIntervalVar = window.setInterval (() => {
        this.getTrainPositions();
      }, 3000 );
    },
    cancelInterval () {
      window.clearInterval(this.trainIntervalVar);
      this.trainIntervalVar = null;
    },
    cancelRequest () {
      if (this.cancelSource) {
        this.cancelSource.cancel();
      }
    },
    changeBaseLayer () {
      if (this.baseLayerBool == true) {
        this.map.removeLayer(this.baseLayers['Satellite']);
        this.map.addLayer(this.baseLayers['Map']);
      } else {
        this.map.removeLayer(this.baseLayers['Map']);
        this.map.addLayer(this.baseLayers['Satellite']);
      }
    },
    async getEventMovieArea () {
      await this.axios.get(`/Config/GetPositionTrackerConfig?installationId=${ this.installationId }`)
        .then((response) => {
          if (response == null) {
            return;
          }
          if (response.data == null) {
            return;
          }
          if (response.data.areas == null) {
            return;
          }
          if (response.data.areas.length == 0) {
            return;
          }
          this.polygonData = response.data.areas;
        });
    },
    async getTrainPositions () {
      this.cancelRequest();
      this.cancelSource = this.axios.CancelToken.source();
      let requestConfig = { cancelToken: this.cancelSource.token };

      await this.axios.get(`/EventMovie/GetEventMoviePositions?installationId=${ this.installationId }`, requestConfig)
        .then((response) => {
          if (response == null) {
            return;
          }
          if (response.data == null) {
            return;
          }
           if (response.status == 200) {
              this.trains = response.data;
              this.updateMappedTrains();
          } else {
              this.cancelInterval();
          }
        }).catch(() => {
          if (this.axios.isCancel()) {
            return;
          }
          this.cancelInterval();
        });
    },
    initMap () {
      if (this.map != null) {
        this.map.remove();
      }
      document.getElementById('eventMovieWrapper').innerHTML = "<div id='map' style='width: 100%; height: 100%; min-height: 500px;'></div>";

      let wikiMap = L.tileLayer(this.wikiUrl, {attribution: this.contributionUrl});
      let landMap = L.tileLayer(this.mapUrl, {attribution: this.mapAttrib});
      // create the map and save it
      this.map = L.map('map', { layers: [wikiMap], zoomDelta: 0.5, zoomSnap: 0 });
      this.baseLayers = {};
      this.baseLayers['Satellite'] = landMap;
      this.baseLayers['Map'] = wikiMap;

      // create the layer that will store the polygons
      this.editableLayers = new L.FeatureGroup();
      if (this.polygonData != null) {
        // convert the area to fit the needed format
        this.polygonData.forEach((area) => {
          area.isActive = false;
          let temporaryPolygon = null;
          let uniqueColor = this.colors[area.id] ? this.colors[area.id] : 'gray';
          if (area.positions[0].latitude != null) {
            let convertedArray = area.positions.map(function (position) {
              return [ position.latitude, position.longitude ];
            });
            // create the default polygon and add it to the layer of editable polygons
            temporaryPolygon = L.polygon(convertedArray, { color: uniqueColor });
            area.drawn = true;
          }
          area.options = {
            color: uniqueColor
          }
          if (temporaryPolygon != null) {
            temporaryPolygon.name = area.name;
            temporaryPolygon.event = area.event;
            temporaryPolygon.command = area.command;
            temporaryPolygon.deviceKey = area.deviceKey;
            temporaryPolygon.receiver = area.receiver;
            temporaryPolygon.id = area.id;
            temporaryPolygon.bindTooltip(`${ area.name ? area.name : this.$t('eventMovieComp.newArea') } (${ area.id })`);
            temporaryPolygon.addTo(this.editableLayers);
          }
          this.layerLength++;
        });
      }
      this.map.addLayer(this.editableLayers);

      // create the layer that will store the Trains
      if (this.trains != null) {
        // convert the area to fit the needed format
        this.trains.forEach((train) => {
          let marker = new L.marker([train.latitude, train.longitude],{icon: train.session.isSessionActive ? this.redIcon : this.blueIcon})
          .bindTooltip(`${ train.name ? train.name : this.$t('eventMovieComp.newArea') } (${ train.ip })`);
          marker.name = train.name;
          this.mappedTrains.push(marker);
          this.map.addLayer(marker);
          this.layerLength++;
        });
      }

      //Legend
      var legend = L.control({ position: "bottomleft" });
      let redMarkerS = this.redMarkerSource;
      let blueMarkerS = this.blueMarkerSource;
      legend.onAdd = function () {
        var div = L.DomUtil.create("div", "legend");
        div.innerHTML += '<h4>Eventmovie Device</h4>';
        div.innerHTML += `<img src="${ redMarkerS }"><span>Active</span><br>`;
        div.innerHTML += `<img src="${ blueMarkerS }"><span>Inactive</span><br>`;
        return div;
      };
      legend.addTo(this.map);

      this.map.fitBounds(this.bounds);
      if (this.bounds._northEast.lat === 0 && this.bounds._northEast.lng === 0 && this.bounds._southWest.lat === 0 && this.bounds._southWest.lng === 0) {
        this.map.setZoom(2);
      }
    },
    getUniqueIndex () {
      let uniqueInt = 0;
      if (this.polygonData != null) {
        let temporaryIdArray = this.polygonData.map(area => {
          return area.id;
        });
        temporaryIdArray.forEach(() => {
          if (temporaryIdArray.includes(uniqueInt)) {
            uniqueInt++;
          }
        });
      }
      return uniqueInt;
    },
    increaseIndex () {
      this.mapIndex++;
    },
    updateMappedTrains () {
      if(this.mappedTrains.length == 0)
      {
        return;
      }
      this.trains.forEach((train) => {
        this.mappedTrains.forEach((mappedTrain) => {
          if(train.name == mappedTrain.name)
          {
            mappedTrain.setLatLng([train.latitude, train.longitude]).update();
            if(train.session.isSessionActive)
            {
              mappedTrain.setIcon(this.redIcon);        
            }
            else
            {
              mappedTrain.setIcon(this.blueIcon);  
            }   
          }
        });
      });
      
      if(this.trains.length > this.mappedTrains.length) //if there is a new Device found which is not on the map, add it to map
      {        
        this.trains.forEach((train) => {
          let found = this.mappedTrains.find(p => p.name == train.name);
          if(!found)
          {
            let marker = new L.marker([train.latitude, train.longitude],{title: train.name, icon: train.session.isSessionActive ? this.redIcon: this.blueIcon});
            marker.name = train.name;
            this.mappedTrains.push(marker);
            this.map.addLayer(marker);
            this.layerLength++;
          }
        });
      }         
    }
  }
}
</script>

<style scoped>
#eventMovieWrapper {
  width: 100%;
  min-height: 500px;
}
</style>

<style>
.eventMovie table {
  /* override Bootstrap's width */
  width: inherit !important;
}
.eventMovie td, th {
  width: auto;
}
.eventMovie td.min, th.min {
  width: 1% !important;
  white-space: nowrap !important;
}

/*Legend specific*/
.legend {
  padding: 6px 8px;
  font: 14px Arial, Helvetica, sans-serif;
  background: white;
  background: rgba(255, 255, 255, 0.8);
  line-height: 24px;
  color: #555;
}
.legend h4 {
  text-align: center;
  font-size: 16px;
  margin: 2px 12px 8px;
  color: #777;
}

.legend span {
  position: relative;
  bottom: 3px;
}

.legend img {
  width: 13px;
  height: 18px;
  float: left;
  margin: 0 8px 0 0;
}

</style>
